import { useRef } from "react";

export interface ImageInputProps {
  onSelect: (file: File) => void;
  disabled?: boolean;
}

/**
 * File / camera picker. On mobile, `capture="environment"` hints the browser to
 * open the rear camera; on desktop it falls back to a normal file chooser.
 */
export function ImageInput({ onSelect, disabled = false }: ImageInputProps) {
  const inputRef = useRef<HTMLInputElement>(null);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) onSelect(file);
    // Reset so selecting the same file again still fires `change`.
    event.target.value = "";
  };

  return (
    <div className="image-input">
      <input
        ref={inputRef}
        type="file"
        accept="image/*"
        capture="environment"
        className="image-input__file"
        aria-label="Take a photo of dominoes"
        disabled={disabled}
        onChange={handleChange}
      />
      <button
        type="button"
        className="image-input__button"
        disabled={disabled}
        onClick={() => inputRef.current?.click()}
      >
        {disabled ? "Analyzing…" : "Take a photo"}
      </button>
    </div>
  );
}
